var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
import explainSubtitle from '../images/contentLabel/label_cc.png';
import cineSame from '../images/contentLabel/label_cine_same.png';
import cmmg0100 from '../images/contentLabel/label_cmmg0100.png';
import cmmg0200 from '../images/contentLabel/label_cmmg0200.png';
import cmmg0300 from '../images/contentLabel/label_cmmg0300.png';
import cmmg0400 from '../images/contentLabel/label_cmmg0400.png';
import cptg0100 from '../images/contentLabel/label_cptg0100.png';
import cptg0200 from '../images/contentLabel/label_cptg0200.png';
import cptg0300 from '../images/contentLabel/label_cptg0300.png';
import cptg0400 from '../images/contentLabel/label_cptg0400.png';
import cptg0500 from '../images/contentLabel/label_cptg0500.png';
import dolby51 from '../images/contentLabel/label_dolby51ch.png';
import dolbyAtmos from '../images/contentLabel/label_dolbyatmos.png';
import dolbyVision from '../images/contentLabel/label_dolbyvision.png';
import drm from '../images/contentLabel/label_drm.png';
import dtx from '../images/contentLabel/label_dtx.png';
import dubbing from '../images/contentLabel/label_dubbing.png';
import dubbingPoster from '../images/contentLabel/label_dubbing2.png';
import event from '../images/contentLabel/label_event.png';
import firstOpen from '../images/contentLabel/label_first_open.png';
import freePoster from '../images/contentLabel/label_free.png';
import free from '../images/contentLabel/label_free2.png';
import hdr from '../images/contentLabel/label_hdr.png';
import hdr10Plus from '../images/contentLabel/label_hdr10plus.png';
import lite from '../images/contentLabel/label_lite.png';
import premium from '../images/contentLabel/label_premium.png';
import purchase from '../images/contentLabel/label_purchase.png';
import quickVod from '../images/contentLabel/label_quick_vod.png';
import subtitle from '../images/contentLabel/label_subtitle.png';
import subtitlePoster from '../images/contentLabel/label_subtitle2.png';
import uhd4k from '../images/contentLabel/label_uhd4k.png';
import tvingOnly from '../images/label/label_only.png';
import tvingOriginal from '../images/label/label_original.png';
import paramount from '../images/label/label_paramount.png';
export var TV_PAGE;
(function (TV_PAGE) {
    // 판
    TV_PAGE["BOARD"] = "BOARD";
    // SUB SUB_BOARD
    TV_PAGE["SUB_BOARD"] = "SUB_BOARD";
    // GNB
    TV_PAGE["GNB"] = "GNB";
    // 리스트
    TV_PAGE["LIST"] = "LIST";
    // 검색
    TV_PAGE["SEARCH"] = "SEARCH";
    // 검색 결과 전체보기 리스트
    TV_PAGE["SEARCHLIST"] = "SEARCHLIST";
    // 상세 진입
    TV_PAGE["DETAIL"] = "DETAIL";
    // 플레이어
    TV_PAGE["PLAYER"] = "PLAYER";
    // 온보딩
    TV_PAGE["ONBOARDING"] = "ONBOARDING";
    // QR
    TV_PAGE["QR"] = "QR";
    // Login
    TV_PAGE["LOGIN"] = "LOGIN";
    // TV Login
    TV_PAGE["TVLOGIN"] = "TVLOGIN";
    // Welcome
    TV_PAGE["WELCOME"] = "WELCOME";
    // 이용권 구매
    TV_PAGE["PURCHASE"] = "PURCHASE";
    // 프로필
    TV_PAGE["PROFILE"] = "PROFILE";
    TV_PAGE["PROFILE_EDIT"] = "PROFILE_EDIT";
    TV_PAGE["PROFILE_IMAGE_LIST"] = "PROFILE_IMAGE_LIST";
    TV_PAGE["PASSWORD"] = "PASSWORD";
    TV_PAGE["PASSWORD_RESET"] = "PASSWORD_RESET";
    // 빌링
    TV_PAGE["BILLING_TICKET"] = "BILLING_TICKET";
    TV_PAGE["BILLING_AFFILIATE"] = "BILLING_AFFILIATE";
    TV_PAGE["BILLING_CAUTION"] = "BILLING_CAUTION";
    TV_PAGE["BILLING_HISTORY"] = "BILLING_HISTORY";
    // 문자 보내기
    TV_PAGE["SMS"] = "SMS";
    // 확인
    TV_PAGE["CERTIFICATION"] = "CERTIFICATION";
    // 설정
    TV_PAGE["SETTING"] = "SETTING";
    // 팝업
    TV_PAGE["POPUP"] = "POPUP";
    TV_PAGE["NOTICE_POPUP"] = "NOTICE_POPUP";
    TV_PAGE["TOAST"] = "TOAST";
    TV_PAGE["PLAYER_BLOCK"] = "PLAYER_BLOCK";
    // TTV 및 긴급점검
    TV_PAGE["EMERGENCY"] = "EMERGENCY";
})(TV_PAGE || (TV_PAGE = {}));
export var DEVICE_TYPE;
(function (DEVICE_TYPE) {
    DEVICE_TYPE["TIZEN"] = "TIZEN";
    DEVICE_TYPE["ANDROIDTV"] = "ANDROIDTV";
    DEVICE_TYPE["WEBOS"] = "WEBOS";
    DEVICE_TYPE["WEB"] = "WEB";
})(DEVICE_TYPE || (DEVICE_TYPE = {}));
export var ONBOARD_SECTION_CODE = {
    TV_ONBOARDING_1: 'TV_ONBOARDING_1',
    TV_ONBOARDING_2: 'TV_ONBOARDING_2',
    TV_ONBOARDING_3: 'TV_ONBOARDING_3',
};
export var COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 365일
export var CACHE_KEY = {
    LEGACY_USER_INFO: 'ui',
    USER_TOKEN: '_user_token',
    TVING_TOKEN: '_tving_token',
    ACCESS_TOKEN: 'accessToken',
    REFRESH_TOKEN: 'refreshToken',
    REGION_CODE: 'region_code',
    AUTH_TOKEN: '_auth_token',
    AUTH_TOKEN_NEW: 'authToken',
    PROFILE_NO: '_profile_no',
    LAST_PASSWORD_UPDATE_DATE: 'TLPUDB35Qhn7',
    LAST_LOGIN_TYPE: 'LAST_LOGIN_TYPE',
    LAST_TVING_ID: 'LAST_TVING_ID',
    LAST_CJONE_ID: 'LAST_CJONE_ID',
    TVINGID_INPUTBOX_TOOLTIP: 'TVINGID_INPUTBOX_TOOLTIP',
    CJONEID_INPUTBOX_TOOLTIP: 'CJONEID_INPUTBOX_TOOLTIP',
    OPENING_SKIP_COUNT: 'OPENING_SKIP_COUNT',
    OPENING_SKIP_POPUP: 'OPENING_SKIP_POPUP',
    AUTO_OPENING_SKIP: 'AUTO_OPENING_SKIP',
    UPGRADE_BILLING: 'UPGRADE_BILLING',
    uuid: 'uuid',
    RECENTLY_SEARCH_KEYWORDS: 'RECENTLY_SEARCH_KEYWORDS',
    BUFFER: 'BUFFER',
    OPEN_SEARCH_PROFILES: 'OPEN_SEARCH_PROFILES',
    OPEN_PARAMOUNT_PROFILES: 'OPEN_PARAMOUNT_PROFILES',
    PLAYER_SUBTITLE_TOOLTIP_FIRST_DISPLAY: 'PLAYER_SUBTITLE_TOOLTIP_FIRST_DISPLAY',
    PLAYER_SUBTITLE_SIZE_INFO: 'PLAYER_SUBTITLE_SIZE_INFO',
    DEVICE_OS_VERSION: 'DEVICE_OS_VERSION',
    DEVICE_APP_VERSION_TIMESTAMP: 'DEVICE_APP_VERSION_TIMESTAMP',
    DEVICE_UHD_SUPPORTED: 'DEVICE_UHD_SUPPORTED',
    DEVICE_MODEL: 'DEVICE_MODEL',
    DEVICE_RESOLUTION_WIDTH: 'DEVICE_RESOLUTION_WIDTH',
    DEVICE_RESOLUTION_HEIGHT: 'DEVICE_RESOLUTION_HEIGHT',
    TVING_PLAYER_DEBUG_CONSOLE: 'tving-player-debug-console',
    CHUNK_RETRY_COUNT: 'CHUNK_RETRY_COUNT',
    // amplitude 미디어코드별 1회 체크용도
    AMPLITUDE_CLICK_START_REPLAY_TV: 'AMPLITUDE_CLICK_START_REPLAY_TV',
    AMPLITUDE_CLICK_PAUSE_TV: 'AMPLITUDE_CLICK_PAUSE_TV',
    AMPLITUDE_CLICK_PLAY_TV: 'AMPLITUDE_CLICK_PLAY_TV',
    AMPLITUDE_CLICK_EPISODE_LIST_TV: 'AMPLITUDE_CLICK_EPISODE_LIST_TV',
    AMPLITUDE_CLICK_SUBTITLE_TV: 'AMPLITUDE_CLICK_SUBTITLE_TV',
    AMPLITUDE_CLICK_SETTING_TV: 'AMPLITUDE_CLICK_SETTING_TV',
};
export var RATING_TYPE;
(function (RATING_TYPE) {
    RATING_TYPE["MOVIE_18"] = "MOVIE_18";
    RATING_TYPE["PROGRAM_19"] = "PROGRAM_19";
})(RATING_TYPE || (RATING_TYPE = {}));
export var RATING_ICON = {
    MOVIE_18: cmmg0400,
    PROGRAM_19: cptg0500,
};
export var LABEL_TYPE;
(function (LABEL_TYPE) {
    LABEL_TYPE["TVING_ORIGINAL"] = "TVING_ORIGINAL";
    LABEL_TYPE["TVING_ONLY"] = "TVING_ONLY";
    LABEL_TYPE["PARAMOUNT"] = "PARAMOUNT";
})(LABEL_TYPE || (LABEL_TYPE = {}));
export var LABEL_IMAGE = {
    TVING_ORIGINAL: tvingOriginal,
    TVING_ONLY: tvingOnly,
    PARAMOUNT: paramount,
};
export var CONTENT_TYPE;
(function (CONTENT_TYPE) {
    CONTENT_TYPE["MOVIE"] = "MOVIE";
    CONTENT_TYPE["PROGRAM"] = "PROGRAM";
    CONTENT_TYPE["EPISODE"] = "EPISODE";
    CONTENT_TYPE["LIVE"] = "LIVE";
    CONTENT_TYPE["CREATOR"] = "CREATOR";
    CONTENT_TYPE["CHARACTER"] = "CHARACTER";
    CONTENT_TYPE["MORE"] = "MORE";
})(CONTENT_TYPE || (CONTENT_TYPE = {}));
export var CONTENT_LABEL_TYPE;
(function (CONTENT_LABEL_TYPE) {
    CONTENT_LABEL_TYPE["CINE_SAME"] = "CINE_SAME";
    CONTENT_LABEL_TYPE["DOLBY_51"] = "DOLBY_51";
    CONTENT_LABEL_TYPE["DOLBY_ATMOS"] = "DOLBY_ATMOS";
    CONTENT_LABEL_TYPE["DOLBY_VISION"] = "DOLBY_VISION";
    CONTENT_LABEL_TYPE["DRM"] = "DRM";
    CONTENT_LABEL_TYPE["DTX"] = "DTX";
    CONTENT_LABEL_TYPE["DUBBING"] = "DUBBING";
    CONTENT_LABEL_TYPE["DUBBING_POSTER"] = "DUBBING_POSTER";
    CONTENT_LABEL_TYPE["FIRST_OPEN"] = "FIRST_OPEN";
    CONTENT_LABEL_TYPE["HDR"] = "HDR";
    CONTENT_LABEL_TYPE["HDR10_PLUS"] = "HDR10_PLUS";
    CONTENT_LABEL_TYPE["LITE"] = "LITE";
    CONTENT_LABEL_TYPE["PREMIUM"] = "PREMIUM";
    CONTENT_LABEL_TYPE["PURCHASE"] = "PURCHASE";
    CONTENT_LABEL_TYPE["QUICK_VOD"] = "QUICK_VOD";
    CONTENT_LABEL_TYPE["SUBTITLE"] = "SUBTITLE";
    CONTENT_LABEL_TYPE["SUBTITLE_POSTER"] = "SUBTITLE_POSTER";
    CONTENT_LABEL_TYPE["UHD_4K"] = "UHD_4K";
    CONTENT_LABEL_TYPE["EVENT"] = "EVENT";
    CONTENT_LABEL_TYPE["EXPLAIN_SUBTITLE"] = "EXPLAIN_SUBTITLE";
    CONTENT_LABEL_TYPE["FREE"] = "FREE";
    CONTENT_LABEL_TYPE["FREE_META"] = "FREE_META";
})(CONTENT_LABEL_TYPE || (CONTENT_LABEL_TYPE = {}));
export var CONTENT_LABEL_IMAGE = {
    CINE_SAME: cineSame,
    DOLBY_51: dolby51,
    DOLBY_ATMOS: dolbyAtmos,
    DOLBY_VISION: dolbyVision,
    DRM: drm,
    DTX: dtx,
    DUBBING: dubbing,
    DUBBING_POSTER: dubbingPoster,
    FIRST_OPEN: firstOpen,
    HDR: hdr,
    HDR10_PLUS: hdr10Plus,
    LITE: lite,
    PREMIUM: premium,
    PURCHASE: purchase,
    QUICK_VOD: quickVod,
    SUBTITLE: subtitle,
    SUBTITLE_POSTER: subtitlePoster,
    UHD_4K: uhd4k,
    EVENT: event,
    EXPLAIN_SUBTITLE: explainSubtitle,
    FREE: free,
    FREE_META: freePoster,
};
export var GRADE_CODE;
(function (GRADE_CODE) {
    // 전체관람가
    GRADE_CODE["CPTG0100"] = "CPTG0100";
    GRADE_CODE["CMMG0100"] = "CMMG0100";
    // 7세 관람가
    GRADE_CODE["CPTG0200"] = "CPTG0200";
    // 12세 관람가
    GRADE_CODE["CPTG0300"] = "CPTG0300";
    GRADE_CODE["CMMG0200"] = "CMMG0200";
    // 15세 관람가
    GRADE_CODE["CPTG0400"] = "CPTG0400";
    GRADE_CODE["CMMG0300"] = "CMMG0300";
    // 청소년 관람불가 (18세)
    GRADE_CODE["CMMG0400"] = "CMMG0400";
    // 청소년 관람불가 (19세)
    GRADE_CODE["CPTG0500"] = "CPTG0500";
})(GRADE_CODE || (GRADE_CODE = {}));
export var GRADE_CODE_IMAGE = {
    // 전체관람가
    CPTG0100: cptg0100,
    CMMG0100: cmmg0100,
    // 7세 관람가
    CPTG0200: cptg0200,
    // 12세 관람가
    CPTG0300: cptg0300,
    CMMG0200: cmmg0200,
    // 15세 관람가
    CPTG0400: cptg0400,
    CMMG0300: cmmg0300,
    // 청소년 관람불가 (18세)
    CMMG0400: cmmg0400,
    // 청소년 관람불가 (19세)
    CPTG0500: cptg0500,
};
export var DAY_CODE;
(function (DAY_CODE) {
    DAY_CODE["PGWD0100"] = "PGWD0100";
    DAY_CODE["PGWD0200"] = "PGWD0200";
    DAY_CODE["PGWD0300"] = "PGWD0300";
    DAY_CODE["PGWD0400"] = "PGWD0400";
    DAY_CODE["PGWD0500"] = "PGWD0500";
    DAY_CODE["PGWD0600"] = "PGWD0600";
    DAY_CODE["PGWD0700"] = "PGWD0700";
})(DAY_CODE || (DAY_CODE = {}));
export var STREAM_INFO_RESULT_CODE;
(function (STREAM_INFO_RESULT_CODE) {
    STREAM_INFO_RESULT_CODE["POSSIBLE_PLAY"] = "000";
    STREAM_INFO_RESULT_CODE["BAN_OVERSEAS"] = "001";
    STREAM_INFO_RESULT_CODE["FAIL_META_INFO"] = "090";
    STREAM_INFO_RESULT_CODE["NO_REGISTER_DRM"] = "060";
    STREAM_INFO_RESULT_CODE["LIMIT_MULTI_CONNECTION"] = "091";
    STREAM_INFO_RESULT_CODE["NO_LOGIN_INFO"] = "010";
    STREAM_INFO_RESULT_CODE["NOT_ADULT_CERTIFICATION"] = "011";
    STREAM_INFO_RESULT_CODE["NOT_LOGIN"] = "100";
    STREAM_INFO_RESULT_CODE["NOT_BUY"] = "150";
    STREAM_INFO_RESULT_CODE["DOWNLOAD"] = "050";
    STREAM_INFO_RESULT_CODE["UPGRADE_BILLING"] = "151";
    STREAM_INFO_RESULT_CODE["BLOCK_LIVE_CHANNEL"] = "080";
    STREAM_INFO_RESULT_CODE["STATE_STREAMINFO_LOADERROR"] = "999";
})(STREAM_INFO_RESULT_CODE || (STREAM_INFO_RESULT_CODE = {}));
/**
 * POPUP_TYPE 별 텍스트 내용 정의
 */
export var POPUP_TYPE_TEXTS = {
    SUBTITLE_NOT_SUPPORTED: [
        '자막 메뉴 이용을 위해서는',
        '최신 버전으로 업데이트가 필요합니다.',
        '기기에서 Google Play Store 접속 후',
        '티빙 앱을 진입하시고 업데이트를 해주세요.',
    ],
    LOAD_CONTENT_INFO_ERROR: ['일시적으로 콘텐츠 정보를 불러올 수 없습니다.', '[확인]을 누르시고 다시 시도해주세요.'],
    CHECK_NETWORK_STATE: ['네트워크 상태를 확인해주세요.'],
    CHECK_NETWORK_STATE_AND_RESTART: ['네트워크 상태를 확인 후', '티빙 앱을 다시 실행해주세요.'],
    END_SERVICE_CONTENT: ['서비스 종료된 콘텐츠로 재생 불가합니다.'],
    WRONG_CONTENT: ['영상에 문제가 있어 재생이 불가합니다.', 'tving@cj.net 으로 문의해주세요'],
    BAN_OVERSEAS: ['티빙 서비스는 국내에서만 이용하실 수 있습니다.', '국내에서 접속 중임에도 메시지가 노출되는 경우', '고객센터로 문의해주세요.'],
    CONFIRM_USER_AUTHENTICATION: ['구독을 위해서는 사용자 인증이 필요합니다.', '진행하시겠습니까?'],
    CONFIRM_ADULT_AUTHENTICATION: ['성인 인증이 필요합니다.', '진행하시겠습니까?'],
    CHECK_OTP_CONFIRM: function (url, keyword) { return ["".concat(url, " \uC73C\uB85C \uC811\uC18D\uD574\uC11C"), "".concat(keyword, " \uC644\uB8CC \uD6C4 TV\uC758 \uC644\uB8CC \uBC84\uD2BC\uC744 \uB20C\uB7EC\uC8FC\uC138\uC694.")]; },
    CHECK_QR_CONFIRM: function (keyword) { return ["QR\uCF54\uB4DC\uB97C \uD1B5\uD574 \uBAA8\uBC14\uC77C\uC6F9\uC5D0 \uC811\uC18D\uD574\uC11C", "".concat(keyword, " \uC644\uB8CC \uD6C4 TV\uC758 \uC644\uB8CC \uBC84\uD2BC\uC744 \uB20C\uB7EC\uC8FC\uC138\uC694.")]; },
    CHECK_PASSWORD: ['계정 비밀번호를 입력해주세요.'],
    NOT_CORRECT_PASSWORD: ['비밀번호가 일치하지 않습니다.', '다시 입력해주세요.'],
    PASSWORD_CHANGED_LOGOUT: ['비밀번호가 변경되어 로그아웃됩니다.'],
    PASSWORD_RESET_COMPLETE: ['비밀번호가 초기화되었습니다.'],
    CONFIRM_SEND_EMAIL: function (email) {
        return [
            "".concat(email, "\uB85C \uBE44\uBC00\uBC88\uD638 \uCD08\uAE30\uD654 URL\uC774 \uBC1C\uC1A1\uB429\uB2C8\uB2E4."),
            '이메일을 발송하시겠습니까?',
            '',
            '사용하는 이메일이 아니라면, App이나 PC의',
            'MY>회원정보 수정에서 이메일 주소를 변경해주세요.',
        ];
    },
    INVALID_EMAIL_ADDRESS: [
        '비밀번호 초기화 링크를 보낼',
        '이메일 주소가 올바르지 않습니다.',
        'App이나 PC의 MY>회원정보 수정에서',
        '이메일 주소를 변경해주세요.',
    ],
    COMPLETE_SEND_EMAIL: ['이메일이 발송되었습니다.', '이메일 링크 비밀번호 초기화 후 프로필을 선택해주세요.'],
    FAIL_SEND_EMAIL: ['이메일이 정상적으로 발송되지 않았습니다.', '잠시 후 다시 시도해주세요.'],
    DO_NOT_DELETE_DEFAULT_PROFILE: ['대표 프로필(첫번째 프로필)은 삭제할 수 없습니다.'],
    CONFIRM_EDIT_CANCEL: ['취소 시, 변경된 내용은 저장되지 않습니다.', '그래도 취소하시겠습니까?'],
    CHECK_PROFILE_VALIDATION: ['프로필 이름은 2자 이상 10자 이내의', '한글, 영문, 숫자만 입력 가능합니다.', '다시 입력해주세요.'],
    CONFIRM_WRITE_CANCEL: ['취소 시, 입력된 내용은 저장되지 않습니다.', '그래도 취소하시겠습니까?'],
    CHECK_PROFILE_NAME: ['프로필 이름을 입력해주세요.'],
    CONFIRM_DELETE_PROFILE: ['정말 삭제하시겠습니까?', '프로필 삭제 시, 모든 데이터가 삭제되며', '복구 할 수 없습니다.'],
    NOT_SUPPORTED_DRM: ['해당 기기는 DRM 재생 불가 단말로 DRM 콘텐츠 재생에 문제가 발생할 수 있습니다.'],
    CONFIRM_DELETE_DEVICE: ['등록된 기기를 삭제하시겠습니까?', '삭제는 월 1회 가능합니다.'],
    COMPLETE_REGISTER_DEVICE: ['기기 등록이 완료되었습니다.'],
    FULL_REGISTERED_DEVICES: ['5대의 기기가 모두 등록되어 있어요.', '등록 기기 삭제 후 다시 시도하세요.'],
    IMPOSSIBLE_DELETE_DEVICE: ['이번달에 삭제한 이력이 있습니다.', '다음 달에 삭제/등록 가능합니다.'],
    FULL_REGISTERED_DEVICES_ERROR: [
        '고객님의 아이디로 5대의 기기가 등록되어 있어 추가 등록이 제한됩니다.',
        '기기등록 메뉴에서 등록된 기기를 관리할 수 있습니다.',
        '기기등록 메뉴로 이동하시겠습니까?',
    ],
    COMPLETE_DEVICE_DELETE: ['기기 삭제가 완료되었습니다.'],
    PROFILE_COUNT_LIMIT_UPGRADE: ['프로필 추가는 이용권 업그레이드 후 이용 가능합니다.', '이용권 변경 안내 페이지로 이동하시겠습니까?'],
    PROFILE_COUNT_LIMIT_PURCHASE: ['프로필 추가 권한이 없습니다.', '이용권을 구매 하시겠습니까?'],
    SALE_END_CONTENTS: ['판매가 종료된 콘텐츠입니다.'],
    UPGRADE_UPSALE_FOR_AFFILIATE: [
        '4K 화질 이용은 이용권 업그레이드 후',
        '이용 가능합니다.',
        '이용권 변경 안내 페이지로',
        '이동하시겠습니까?',
    ],
    USE_AFTER_UPGRADE: ['TV에서 시청하시려면 이용권', '업그레이드 후 이용 가능합니다.'],
    UPGRADE_UPSALE: ['스탠다드 회원이시군요!', '해당 콘텐츠는 4K 화질 제공 콘텐츠로', '프리미엄으로 업그레이드 하시면', '4K 화질로 시청 가능합니다.'],
    ALREADY_USE_TICKET: ['현재 구독중인 이용권과', '동일한 이용권입니다.'],
    NO_LOGIN_INFO: ['계정 정보를 불러올 수 없습니다.', '로그아웃 합니다.'],
    GUIDE_SKIP_OPENING: [
        '오프닝 건너뛰기 기능을 자주 사용하시네요!',
        "'자동 오프닝 건너뛰기' 기능을 ON 설정하시면",
        '자동으로 오프닝 구간이 점프됩니다.',
        '지금 바로 설정하실래요?',
    ],
    PURCHASED_CHECK_TEXTS: {
        // 다른 구글 계정으로 로그인한 경우 + 구글 정기결제 기간이 만료되어서 purchase token은 없어졌으나, 티빙은 23:59:59 가 안되어 아직 이용권이 남아 있는 경우
        CHANGE_GOOGLE_ACCOUNT: [
            '이용권 변경이 불가능합니다.',
            '구매한 Google 계정이 맞는지 혹은 정기결제가 정상적으로 이뤄졌는지 확인해주세요. (Play 스토어>정기결제 복원)',
        ],
        // 다른 티빙 계정으로 로그인한 경우
        CHANGE_TVING_ACCOUNT: ['이미 다른 티빙 계정으로 이용권을 구독 중입니다.', '구독 중인 아이디를 확인해 주세요.'],
        CHANGE_ANOTHER_POC: [
            'PC, 모바일 웹 또는 iOS 기기에서 결제한',
            '이용권은 해당 기기에서 변경할 수 있습니다.',
            '(2022년 4월 이전 Android 기기에서 결제한 이용권 포함)',
        ],
        CHANGE_ANOTHER_POC_APP: ['Android App(Mobile, Tablet)에서 결제한 이용권은', '해당 기기에서 변경 가능하며 Android TV에서는 변경 불가능합니다.'],
        ALREADY_USE: ['Android 기기에서 결제한 이용권은', 'Play 스토어에서 변경할 수 있습니다.'],
        ALREADY_CHANGE: ['이용권 변경은 매월1회 가능합니다.'],
        NEED_RESTORE: ['이용권을 결제하셨으나 오류가 발생하여 이용권 지급에 실패했습니다.', '이용권 화면 하단의 구매내역 복원 버튼을 눌러주세요.'],
        ERROR: ['오류가 발생했습니다.', '다시 시도해주세요.'],
        RESTORE_SUCCESS: ['구매 내역이 복원되었습니다.'],
        RESTORE_FAIL_CHECK_ACCOUNT: ['구매 복원할 내역이 없습니다.', '로그인 된 계정을 확인해주세요.'],
        RESTORE_FAIL_TRY_AGAIN: ['구매 복원에 실패하였습니다.', '다시 시도해주세요.'],
        PURCHASE_SUCCESS: ['이용권 구독이 완료되었습니다.'],
    },
    LOGOUT: ['로그아웃 하시겠어요?'],
    EXIT: ['정말 TVING을 종료하시겠습니까?'],
    LG_CANNOT_REGISTER_COUPON: ['LG U+ 이용권 보유시', '쿠폰 등록이 불가능합니다.'],
    KT_CANNOT_REGISTER_COUPON: ['KT 이용권 보유시', '쿠폰 등록이 불가능합니다.'],
    TICKET_OWNER_CANNOT_REGISTER_COUPON: ['이용권 구독 중으로 쿠폰을 등록할 수 없습니다.'],
    CORRECT_PHONE_NUMBER: ['휴대폰 번호를 정확히 입력해주세요.'],
    CAN_BUY_PC_MOBILE: ['해당 콘텐츠는 PC Web에서만 구매가 가능합니다.'],
    UPDATE_VERSION: [
        '안정적인 티빙 서비스 제공을 위하여',
        '최신 업데이트 사항을 적용하고자 합니다.',
        '[확인] 을 누르시면 자동으로 앱이 재시작되면서',
        '업데이트 적용이 완료됩니다.',
    ],
    END_CONTENT: ['서비스가 종료된 콘텐츠입니다.'],
    LOGIN_FAILED: ['일치하는 회원정보가 없습니다.', '이용하시는 계정 유형(TVING/CJ ONE)과', '아이디, 비밀번호를 다시 확인해주세요.'],
    LOGIN_DORMANCY_FAILED: ['회원님의 계정은 현재 휴면 상태입니다.', '스마트폰에서만 로그인이 가능합니다.'],
    PROVISIONING_6001_ERROR: ['서비스를 지원하지 않는 국가입니다.', '앱이 종료됩니다.'],
    PROVISIONING_6003_ERROR: ['일시적인 오류가 발생하였습니다.', '잠시 후 다시 시도해주세요.'],
    NOT_ONAIR_TIME: ['라이브 시작 후 시청 가능합니다.'],
};
export var SMS_TYPE;
(function (SMS_TYPE) {
    SMS_TYPE["ADULT"] = "adult";
    SMS_TYPE["USER"] = "user";
    SMS_TYPE["PPV"] = "ppv";
    SMS_TYPE["TICKET"] = "ticket";
    SMS_TYPE["COUPON"] = "coupon";
})(SMS_TYPE || (SMS_TYPE = {}));
export var SMS_TITLE = (_a = {},
    _a[SMS_TYPE.ADULT] = '성인 인증',
    _a[SMS_TYPE.USER] = '사용자 인증',
    _a[SMS_TYPE.TICKET] = '이용권 구독하기',
    _a[SMS_TYPE.PPV] = '개별 구매하기',
    _a[SMS_TYPE.COUPON] = '쿠폰 등록하기',
    _a);
export var CERTIFICATION_TITLE = __assign(__assign({}, SMS_TITLE), (_b = {}, _b[SMS_TYPE.PPV] = '휴대폰 문자로 구매하기', _b[SMS_TYPE.TICKET] = '휴대폰 문자로 구매하기', _b));
export var SMS_DESCRIPTION = (_c = {},
    _c[SMS_TYPE.ADULT] = ['휴대폰 번호 입력 후 [문자 보내기] 버튼을 누르면', '성인 인증이 가능한 링크를 문자로 발송해드립니다.'],
    _c[SMS_TYPE.USER] = ['사용자 인증 가능한 링크를 문자로 발송해드립니다.'],
    _c[SMS_TYPE.PPV] = ['개별 구매 가능한 링크를 문자로 보내드립니다.'],
    _c[SMS_TYPE.TICKET] = ['이용권 구독 가능한 링크를 문자로 보내드립니다.'],
    _c[SMS_TYPE.COUPON] = ['쿠폰 등록 가능한 링크를 문자로 보내드립니다.'],
    _c);
export var CERTIFICATION_DESCRIPTION = (_d = {},
    _d[SMS_TYPE.ADULT] = [
        '문자로 전송된 URL 링크를 클릭하세요.',
        '휴대폰에서 사용자 인증을 진행하세요.',
        '인증이 완료되면 TV에서 즉시 시청이 가능합니다.',
    ],
    _d[SMS_TYPE.USER] = [
        '문자로 전송된 URL 링크를 클릭하세요.',
        '휴대폰에서 사용자 인증을 진행하세요.',
        '인증이 완료되면 TV에서 이용권 구독이 가능합니다.',
    ],
    _d[SMS_TYPE.PPV] = ['문자로 전송된 URL 링크를 클릭하세요.', '휴대폰에서 개별 구매를 진행하세요.', '등록이 완료되면 아래 [확인] 버튼을 눌러주세요.'],
    _d[SMS_TYPE.TICKET] = [
        '문자로 전송된 URL 링크를 클릭하세요.',
        '휴대폰에서 이용권 구독을 진행하세요.',
        '등록이 완료되면 아래 [확인] 버튼을 눌러주세요.',
    ],
    _d[SMS_TYPE.COUPON] = [
        '문자로 전송된 URL 링크를 클릭하세요.',
        '휴대폰에서 쿠폰 등록을 진행하세요.',
        '등록이 완료되면 아래 [확인] 버튼을 눌러주세요.',
    ],
    _d);
export var DEVICE_LEVEL;
(function (DEVICE_LEVEL) {
    DEVICE_LEVEL["LOW"] = "LOW";
    DEVICE_LEVEL["NORMAL"] = "NORMAL";
})(DEVICE_LEVEL || (DEVICE_LEVEL = {}));
export var LOGIN_DESCRIPTION = {
    MOBILE_LOGIN: ['스마트폰 카메라로 QR코드를 화면에 비추면', '빠르게 로그인할 수 있어요.'],
    TV_LOGIN: ['TVING ID 또는 CJ ONE ID 회원만', 'TV 리모컨으로 직접 입력하여 로그인할 수 있어요.'],
    ETC_LOGIN: ['TV에서 로그인은 TVING ID와 CJ ONE ID만 가능합니다.', '네이버, 카카오 등 그 외 계정은 스마트폰에서 로그인해주세요.'],
};
export var TV_LOGIN_TYPE;
(function (TV_LOGIN_TYPE) {
    TV_LOGIN_TYPE["CJONE_ID"] = "10";
    TV_LOGIN_TYPE["TVING_ID"] = "20";
    TV_LOGIN_TYPE["OTHER"] = "OTHER";
})(TV_LOGIN_TYPE || (TV_LOGIN_TYPE = {}));
export var CUSTOMER_INFORMATION = {
    ID: '아이디를 잊으신 경우 tving@cj.net으로 문의 남겨주시면 빠르게 도움 드리겠습니다.',
    PASSWORD: '비밀번호를 잊으신 경우 모바일 앱 또는 PC에서 [비밀번호 찾기]를 통해 확인해주세요.',
};
export var PROVISIONING_ERROR;
(function (PROVISIONING_ERROR) {
    PROVISIONING_ERROR["PROVISIONING_6001_ERROR"] = "6001";
    PROVISIONING_ERROR["PROVISIONING_6003_ERROR"] = "6003";
})(PROVISIONING_ERROR || (PROVISIONING_ERROR = {}));
export var BFF_API_ERROR;
(function (BFF_API_ERROR) {
    BFF_API_ERROR["ERROR_500"] = "ERROR_500";
})(BFF_API_ERROR || (BFF_API_ERROR = {}));
